import React from 'react';
import BaseActionForm from '../BaseActionForm';
import { Button } from "react-bootstrap";
import ApiService from "../../services/ApiService";
import './styles.scss'
import { useNavigate, useLocation } from 'react-router-dom'
import DropdownWithFilter from '../../components/DropdownWithFilter';
import BackArrow from './../../assets/BackArrow.svg'

export default function Publisher(props) {
    const navigation = useNavigate() // extract navigation prop here 
    const { state } = useLocation();
    return <PublisherClass {...props} dataset={props.choosenDataset? props.choosenDataset : (state && state.params && state.params.E_dataset)} navigation={navigation} /> //pass to your component.
}
class PublisherClass extends BaseActionForm {

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            myDatasets: null,
            dataset: null,
            processResult: null,
            onErrorWithProcesses: false
        }
    }

    async componentDidMount() {
        super.componentDidMount();

        this.startLoading();
        let response = await Promise.all([
            ApiService.getMyDatasets()
        ]);
        this.stopLoading();
        if (this.checkStatus(response)) {
            this.setState({
                myDatasets: response[0].datasets
            }, () => {
                this.props.dataset && this.handleDatasetSelect(this.props.dataset)
            });
        }
    }

    handleDatasetSelect = (dataset) => {
        this.setState(
            {
                dataset: dataset,
                //filters: null
            }, () => {
                if (dataset && ApiService.checkActiveProcess(dataset, 'lk_publisher')) {
                    this.setState({ onErrorWithProcesses: true })
                }
                this.datasetProcessCheck(dataset)
            }
        );
    }

    updateAndCheckDataset = (dataset) => {
        if (dataset) {
            ApiService.getMyDatasets().then((response) => {
                if (this.checkStatus(response)) {

                    response.datasets.forEach((newDataset) => {
                        if (newDataset._id["$oid"] === dataset._id["$oid"]) {
                            this.setState({
                                dataset: newDataset,
                                onErrorWithProcesses: ApiService.checkActiveProcess(newDataset, 'lk_publisher')
                            });
                        }
                    })
                }

                this.stopLoading();
            });
        }
    }

    onStartProcess = () => {
        if (this.state.dataset && !this.state.onErrorWithProcesses) {
            ApiService.createLKPublisherTask(this.state.dataset.dataset).then((response) => {
                this.setState({ processResult: response, onErrorWithProcesses: true });
                setTimeout(() => { this.setState({ processResult: null }) }, 5000);
            });
        }
    };

    datasetProcessCheck = (dataset) => {
        this.checkInterval && clearInterval(this.checkInterval);
        if (dataset) {
            this.checkInterval = setInterval(() => {
                this.startLoading();
                this.updateAndCheckDataset(dataset)
            }, 5000);
        }
    }

    render() {

        return (
            <div className='twoHalfs'>
                <div id={"exporter"} className={"flexColumn rightPanel"}>
                    {this.renderAlerts()}

                    <div className="headerContainer">
                        {this.props && !this.props.dataset && <img src={BackArrow} className='backArrow' alt='back arrow' onClick={() => this.props.navigation(-1)} />}
                        <div className='titleContainer'><p className="headerMargin">Публикация на карту</p></div>
                    </div>


                    {this.props && this.props.dataset && <div className="bottomHeaderContainer">
                        <p>{this.props.dataset.name}</p>
                    </div>}


                    <div className="postHeaderContainer textRoboto infoContainer">

                        {this.state.myDatasets &&
                            <>
                                <p className="textBottom">Hабор данных</p>
                                <DropdownWithFilter
                                    className="dropSelectDataset"
                                    items={this.state.myDatasets}
                                    selectedItem={this.state.dataset}
                                    onItemClick={(item) => { this.handleDatasetSelect(item) }}
                                    label={(item) => { return item.name || "(не установлено)"; }}
                                    defaultLabel={"Bыберите"}
                                /></>
                        }

                        {(this.state.dataset && this.state.dataset.geoportalLayerId && this.state.dataset.publicate) &&
                            <div className='textBottom'>
                                Уже было опубликовано{(this.state.dataset.publicate ? '(' + ApiService.prettyDateTime(new Date(parseInt(this.state.dataset.publicate.time["$date"]["$numberLong"]))) + ')' : "") + ", "}
                                <a href={"https://rk.geosamara.ru/map/?defaultLayers=tms51_layer," + this.state.dataset.geoportalLayerId} target="_blank" rel="noreferrer">посмотреть на карте</a>
                            </div>
                        }
                    </div>
                    {
                        (this.state.processResult)
                            ?
                            <div className='textBottom'>
                                {(this.state.processResult.status === "success")
                                    ?
                                    <div>
                                        <p className='textBottom'>Запущена публикация на карту</p>
                                    </div>
                                    :
                                    <p className='textBottom'>Произошла ошибка: {this.state.processResult.errorMessageRu}</p>
                                }
                            </div>
                            :
                            (this.state.dataset) &&
                            <Button className='applyInstrument' style={this.state.onErrorWithProcesses ? { opacity: '0.3', pointerEvents: 'none' } : { opacity: '1' }} onClick={this.onStartProcess}>Запустить публикацию</Button>
                    }
                    <p className={'infoProcesses textBottom'} style={this.state.onErrorWithProcesses ? { display: 'inline' } : { display: 'none' }}> Дождитесь завершения запущеных процессов </p>

                </div>

                <div className='rightHalf'></div>

            </div>
        );
    }
}











